/* eslint-disable  @typescript-eslint/no-explicit-any */ // AJB: remove
"use client";

import AdDetailModel from "@/models/AdDetailModel";
import { Box, Theme, Typography } from "@mui/material";
import AdSummary from "./AdSummary";
import AdPedigreeTree from "./AdPedigreeTree";
import AdMeta from "./AdMeta";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { AdPendingAlert } from "./AdPendingAlert";
import { AdInsuranceEstimate } from "./AdInsuranceEstimate";
import { AD_DETAILS_2_COLUMN_MAX_WIDTH } from "@/app/layout/LayoutConstants";
import { TrackedLink } from "@/components/shared/TrackedLink";
import { CreateAnalyticEvent } from "@/actions/details/CreateAnalyticEvent";
import { AdNutritionWidget } from "./AdNutritionWidget";
import AdBreadcrumbs from "./AdBreadcrumbs";
import { AdActions } from "@/app/shared/ad/AdActions";

export const AD_DESCRIPTION_STYLING = (theme: Theme) => ({
  "& p": {
    margin: theme.spacing(0.25, 0),
    minHeight: "1.5em",
  },
  "& a": {
    textDecoration: "underline",
  },
  "& ul, & ol": {
    paddingLeft: theme.spacing(4),
    margin: theme.spacing(1, 0),
  },
});

export default function AdBody({ ad }: { ad: AdDetailModel }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 4,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          alignItems: "stretch",
        }}
      >
        <AdPendingAlert ad={ad} />
        <Box
          sx={(theme) => ({
            display: "grid",
            gridTemplateColumns: "minmax(0, 1fr) 160px",
            gap: theme.spacing(4),
            [theme.breakpoints.down("sm")]: {
              gridTemplateColumns: "minmax(0, 1fr)",
            },
          })}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              width: "100%",
            }}
          >
            <AdBreadcrumbs ad={ad} />
            <Typography
              variant="h4"
              component="h1"
              sx={(theme) => ({
                fontWeight: "bold",
                [theme.breakpoints.down("md")]: {
                  fontSize: "1.5rem",
                },
                display: "flex",
                alignItems: "start",
                gap: 2,
              })}
            >
              {ad.title}
              <Box
                component="span"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  lineHeight: 0,
                }}
              >
                <AdActions ad={ad} iconOnly />
              </Box>
            </Typography>
            <TrackedLink
              href={`https://www.google.com/maps/search/?api=1&query=${ad.location.label}`}
            >
              <Typography
                sx={{
                  textDecoration: "underline",
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                }}
              >
                {ad.location.label}
                <OpenInNewIcon sx={{ height: "14px" }} />
              </Typography>
            </TrackedLink>
            <AdMeta ad={ad} />
            <Box sx={{ marginTop: 3, marginBottom: 3 }}>
              <AdSummary ad={ad} />
            </Box>
            <Typography
              component="div"
              sx={AD_DESCRIPTION_STYLING}
              onClick={(e: any) => {
                if (e.target.href) {
                  CreateAnalyticEvent({
                    event: {
                      adIds: [ad.id],
                      eventType: "CLICK#LINK#OUT",
                      metadata: {
                        href: e.target.href,
                        text: e.target.textContent || "NONE",
                      },
                    },
                  });
                }
              }}
              dangerouslySetInnerHTML={{
                __html: ad.descriptionHtml,
              }}
            />
          </Box>
          {ad.insurance && (
            <Box
              sx={(theme) => ({
                display: "flex",
                flexDirection: "column",
                gap: 4,
                marginRight: -2,
                [theme.breakpoints.down(AD_DETAILS_2_COLUMN_MAX_WIDTH)]: {
                  margin: theme.spacing(1, 0),
                },
              })}
            >
              <AdInsuranceEstimate insurance={ad.insurance} />{" "}
              {ad.ott && <AdNutritionWidget adId={ad.id} />}
            </Box>
          )}
        </Box>
      </Box>
      <AdPedigreeTree ad={ad} />
    </Box>
  );
}
